// src/components/ui/LoadingSpinner.tsx
import React from 'react';
import { motion } from 'framer-motion';
import { Loader2, Zap } from 'lucide-react';
import { clsx } from 'clsx';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'brand';
  className?: string;
  text?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  variant = 'default',
  className,
  text,
}) => {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  const textSizes = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
  };

  if (variant === 'brand') {
    return (
      <div className={clsx('flex flex-col items-center justify-center space-y-4', className)}>
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
          className={clsx(
            'bg-gradient-to-r from-primary-500 to-primary-600 rounded-lg flex items-center justify-center',
            sizes[size]
          )}
        >
          <Zap className="w-1/2 h-1/2 text-white" />
        </motion.div>
        {text && (
          <p className={clsx('text-gray-600 dark:text-gray-400 font-medium', textSizes[size])}>
            {text}
          </p>
        )}
      </div>
    );
  }

  return (
    <div className={clsx('flex flex-col items-center justify-center space-y-2', className)}>
      <Loader2 className={clsx('animate-spin text-primary-600', sizes[size])} />
      {text && (
        <p className={clsx('text-gray-600 dark:text-gray-400', textSizes[size])}>
          {text}
        </p>
      )}
    </div>
  );
};